var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-div"},[_c('div',{ref:"map-room",attrs:{"id":"map-room"}},[_c('mainItem',{ref:"mainItem",attrs:{"mainObj":_vm.mainObj}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }